// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as OrderStage from "../../../../ticket-dashboard/app/tickets/entities/OrderStage.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as GeoRegionHook from "../../../../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as IssueSectionV2 from "../form-sections-v2/IssueSectionV2.bs.js";
import * as TicketRaisedBy from "../../../../ticket-dashboard/app/tickets/entities/TicketRaisedBy.bs.js";
import * as ActionSectionV2 from "../form-sections-v2/ActionSectionV2.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as CommentSectionV2 from "../form-sections-v2/CommentSectionV2.bs.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as BasicInfoSectionV2 from "../form-sections-v2/BasicInfoSectionV2.bs.js";
import * as RaiseTicketDataMachine from "../../../app/repo/RaiseTicketDataMachine.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function extractLiveData(loadable) {
  if (typeof loadable === "number" || loadable.TAG !== /* Live */1) {
    return ;
  } else {
    return Caml_option.some(loadable._0);
  }
}

function RaiseTicketPageV2(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var country = Props.country;
  var basicForm = BasicInfoSectionV2.Form.useForm(BasicInfoSectionV2.getInitialInput(state.selected_basic_info), {
        country: country
      }, (function (param, param$1) {
          
        }));
  var issueForm = IssueSectionV2.Form.useForm(IssueSectionV2.getInitialInput(state.issue_form_data), (function (param, param$1) {
          
        }));
  var actionForm = ActionSectionV2.Form.useForm(ActionSectionV2.getInitialInput(state.action_form_data), (function (param, param$1) {
          
        }));
  var isIssueCommentRequired = Belt_Option.mapWithDefault(extractLiveData(state.categorized_issues), false, (function (data) {
          return IssueSectionV2.isCommentRequired(data, issueForm.input.selectedIssues);
        }));
  var isActionCommentRequired = Belt_Option.mapWithDefault(extractLiveData(state.actions), false, (function (data) {
          return ActionSectionV2.isCommentRequired(data, actionForm.input.selectedActions);
        }));
  var isCommentSectionVisible = isIssueCommentRequired || isActionCommentRequired;
  var commentForm = CommentSectionV2.Form.useForm(CommentSectionV2.getInitialInput(undefined), {
        isCommentRequired: isCommentSectionVisible
      }, (function (param, param$1) {
          
        }));
  React.useEffect((function () {
          Curry._2(commentForm.updateComment, (function (param, v) {
                  return {
                          comment: v
                        };
                }), commentForm.input.comment);
          
        }), [isCommentSectionVisible]);
  var georegions = GeoRegionHook.useGeoRegions(country);
  var liveOrderStage = OrderStage.fromString(basicForm.input.orderStage);
  var fetchIssues = function (orderStage) {
    Curry._1(dispatch, {
          TAG: /* SetCategorizedIssues */3,
          categorized_issues: {
            TAG: /* Loading */0,
            _0: undefined
          }
        });
    return RaiseTicketDataMachine.fetchTicketIssuesV2(orderStage, country, (function (issues) {
                  return Curry._1(dispatch, {
                              TAG: /* SetCategorizedIssues */3,
                              categorized_issues: {
                                TAG: /* Live */1,
                                _0: issues
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetCategorizedIssues */3,
                              categorized_issues: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }));
  };
  var fetchActions = function (orderStage) {
    Curry._1(dispatch, {
          TAG: /* SetAvailableActions */2,
          actions: {
            TAG: /* Loading */0,
            _0: undefined
          }
        });
    return RaiseTicketDataMachine.fetchTicketActions(orderStage, country, (function (actions) {
                  return Curry._1(dispatch, {
                              TAG: /* SetAvailableActions */2,
                              actions: {
                                TAG: /* Live */1,
                                _0: actions
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetAvailableActions */2,
                              actions: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }));
  };
  React.useEffect((function () {
          if (liveOrderStage !== undefined) {
            Curry._1(issueForm.reset, undefined);
            fetchIssues(liveOrderStage);
          }
          
        }), [liveOrderStage]);
  React.useEffect((function () {
          if (liveOrderStage !== undefined) {
            Curry._1(actionForm.reset, undefined);
            fetchActions(liveOrderStage);
          }
          
        }), [liveOrderStage]);
  var retryIssues = function (param) {
    if (liveOrderStage !== undefined) {
      return fetchIssues(liveOrderStage);
    }
    
  };
  var retryActions = function (param) {
    if (liveOrderStage !== undefined) {
      return fetchActions(liveOrderStage);
    }
    
  };
  var dataReady = Belt_Option.mapWithDefault(extractLiveData(state.categorized_issues), false, (function (data) {
          return Belt_List.length(data.categories) > 0;
        })) && Belt_Option.mapWithDefault(extractLiveData(state.actions), false, (function (data) {
          return Belt_List.length(data.actions) > 0;
        }));
  switch (georegions.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement("div", {
                    className: "c-raise-ticket-page-v2"
                  }, React.createElement("div", {
                        className: "raise-ticket-v2-columns"
                      }, React.createElement("div", {
                            className: "raise-ticket-v2-left-col"
                          }, React.createElement(BasicInfoSectionV2.make, {
                                form: basicForm,
                                georegions: georegions._0
                              })), React.createElement("div", {
                            className: "raise-ticket-v2-right-col"
                          }, React.createElement(IssueSectionV2.make, {
                                form: issueForm,
                                categorized_issues: state.categorized_issues,
                                hasOrderStage: Belt_Option.isSome(liveOrderStage),
                                onRetry: retryIssues
                              }), React.createElement(ActionSectionV2.make, {
                                form: actionForm,
                                actions: state.actions,
                                hasOrderStage: Belt_Option.isSome(liveOrderStage),
                                onRetry: retryActions
                              }), isCommentSectionVisible ? React.createElement(CommentSectionV2.make, {
                                  form: commentForm
                                }) : null)), React.createElement("div", {
                        className: "raise-ticket-v2-submit-bar"
                      }, React.createElement(Button$Catalyst.make, {
                            text: "Submit",
                            cb: (function (param) {
                                Curry._1(basicForm.submit, undefined);
                                Curry._1(issueForm.submit, undefined);
                                Curry._1(actionForm.submit, undefined);
                                Curry._1(commentForm.submit, undefined);
                                var allValid = Curry._1(basicForm.valid, undefined) && Curry._1(issueForm.valid, undefined) && Curry._1(actionForm.valid, undefined) && Curry._1(commentForm.valid, undefined);
                                if (!allValid) {
                                  return ;
                                }
                                var match = TicketRaisedBy.fromString(basicForm.input.raisedBy);
                                if (match === undefined) {
                                  return ;
                                }
                                if (liveOrderStage === undefined) {
                                  return ;
                                }
                                var payload_caller_number = basicForm.input.callerNumber;
                                var payload_msisdn = basicForm.input.msisdn;
                                var payload_crn = basicForm.input.crn;
                                var payload_location = basicForm.input.location.trim();
                                var payload_issue = issueForm.input.selectedIssues;
                                var payload_ticket_action = actionForm.input.selectedActions;
                                var payload_issue_comments = isIssueCommentRequired ? Belt_Option.getWithDefault(commentForm.input.comment, "").trim() : "";
                                var payload_action_comments = isActionCommentRequired ? Belt_Option.getWithDefault(commentForm.input.comment, "").trim() : "";
                                var payload_start_ts = DateTime$Catalyst.now(undefined);
                                var payload_callback_language = state.selected_basic_info.callback_language;
                                var payload = {
                                  caller_number: payload_caller_number,
                                  msisdn: payload_msisdn,
                                  crn: payload_crn,
                                  location: payload_location,
                                  order_stage: liveOrderStage,
                                  raised_by: match,
                                  issue: payload_issue,
                                  ticket_action: payload_ticket_action,
                                  issue_comments: payload_issue_comments,
                                  action_comments: payload_action_comments,
                                  start_ts: payload_start_ts,
                                  callback_language: payload_callback_language
                                };
                                Curry._1(dispatch, {
                                      TAG: /* UpdateCreateTicketResponse */9,
                                      create_ticket_response: {
                                        TAG: /* Loading */0,
                                        _0: undefined
                                      }
                                    });
                                return RaiseTicketDataMachine.raiseTicket(payload, country, (function (ticket_response) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* UpdateCreateTicketResponse */9,
                                                          create_ticket_response: {
                                                            TAG: /* Live */1,
                                                            _0: ticket_response
                                                          }
                                                        });
                                            }), (function (error) {
                                              Curry._1(dispatch, {
                                                    TAG: /* UpdateCreateTicketResponse */9,
                                                    create_ticket_response: {
                                                      TAG: /* Error */2,
                                                      _0: error
                                                    }
                                                  });
                                              EventTracker.publishEvent({
                                                    category: "Raise Ticket V2",
                                                    action: "Raise Ticket Failure",
                                                    label: "Random",
                                                    value: undefined,
                                                    nonInteraction: undefined
                                                  });
                                              return Curry._1(dispatch, {
                                                          TAG: /* OpenSnackbar */8,
                                                          snackbar_message: {
                                                            TAG: /* Error */1,
                                                            _0: "Failed to create ticket. Please try again."
                                                          }
                                                        });
                                            }));
                              }),
                            className: "raise-ticket-btn raise-ticket-v2-submit",
                            disabled: !dataReady
                          })));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: georegions._0
                  });
    
  }
}

var make = RaiseTicketPageV2;

export {
  extractLiveData ,
  make ,
  
}
/* react Not a pure module */
